<template>
  <div>
    <a-dropdown
      @visibleChange="onColumnsToggle"
      v-model="columnsVisible"
      :trigger="['click']"
    >
      <a-badge :dot="!!hiddenColumns.length">
        <a-button type="primary" icon="table"></a-button>
      </a-badge>
      <a-form class="form" slot="overlay">
        <div class="button" v-if="rights.meta">
          <a-button
            @click.prevent="columnsVisible = false; $refs.modal.open()"
            block
            type="primary"
            size="small"
            >Новая колонка</a-button
          >
        </div>
        <draggable :list="localSortedColumns" handle=".checkbox__dragger">
          <div
            class="checkbox"
            v-for="column in localSortedColumns"
            :key="column.id"
          >
            <a-icon class="checkbox__dragger" type="menu"></a-icon>
            <a-checkbox
              :checked="visibleColumns.includes(column.value)"
              @change="handleColumnsChange(column.value, $event.target.checked)"
            >
              {{ column.label }}
            </a-checkbox>
            <a-icon
              v-if="rights.meta"
              @click.prevent="
                columnsVisible = false;
                $refs.modal.open(column.value);
              "
              class="checkbox__edit"
              type="edit"
            ></a-icon>
          </div>
        </draggable>
        <div class="button">
          <a-button
            @click.prevent="saveColumns"
            block
            type="primary"
            size="small"
            >Сохранить</a-button
          >
        </div>
      </a-form>
    </a-dropdown>
    <modal ref="modal" />
  </div>
</template>

<script>
import draggable from 'vuedraggable';
import Modal from './Modal.vue';

export default {
  name: 'columns',
  components: { draggable, Modal },
  data() {
    return {
      columnsVisible: false,
      visibleColumns: [],
      localSortedColumns: [],
    };
  },
  computed: {
    entities() {
      return this.$store.getters.entities;
    },
    columns() {
      return Object.values(this.entities[this.currentEntity].params)
        .map(v => ({
          label: v.gui_name || v.name,
          value: v.name,
        }));
    },
    columnsSettings() {
      let obj = this.$store.getters.columnsSettings.find(v => v.entity === this.currentEntity);
      obj = {
        hidden: [],
        sorted: [],
        ...obj,
      };

      return obj;
    },
    hiddenColumns() {
      return this.columnsSettings.hidden;
    },
    globalSortedColumns() {
      return this.columnsSettings.sorted;
    },
  },
  watch: {
    entities: {
      handler() {
        this.resetColumns();
      },
      deep: true,
    },
    currentEntity() {
      this.resetColumns();
    },
    hiddenColumns() {
      this.resetColumns();
    },
  },
  methods: {
    resetColumns() {
      this.visibleColumns = this.columns
        .filter(v => !this.hiddenColumns.includes(v.value))
        .map(v => v.value);
      this.localSortedColumns = this.columns
        .sort((a, b) => this.globalSortedColumns.indexOf(a.value)
        - this.globalSortedColumns.indexOf(b.value));
    },
    onColumnsToggle(visible) {
      if (!visible) {
        this.resetColumns();
      }
    },
    handleColumnsChange(val, checked) {
      if (checked) {
        this.visibleColumns.push(val);
        return;
      }

      this.visibleColumns = this.visibleColumns.filter(v => v !== val);
    },
    saveColumns() {
      const hiddenColumns = this.columns
        .filter(v => !this.visibleColumns.includes(v.value))
        .map(v => v.value);
      const sortedColumns = this.localSortedColumns.map(v => v.value);
      this.$store.commit('setColumnsSettings', { entity: this.currentEntity, hidden: hiddenColumns, sorted: sortedColumns });
      this.columnsVisible = false;
    },
  },
  created() {
    this.resetColumns();
  },
};
</script>

<style lang="scss" scoped>
.button {
  margin: 8px;
}

.checkbox {
  display: flex;
  align-items: center;
  padding: 3px 8px;

  &:hover {
    background-color: rgba(0, 0, 0, 0.05);

    .checkbox__edit {
      opacity: 1;
    }
  }

  &__dragger {
    margin-right: 7px;
    cursor: grab;
  }

  &__edit {
    margin-left: auto;
    cursor: pointer;
    opacity: 0;

    &:hover {
      color: #1890ff;
    }
  }
}
</style>
